import { TrainingAPI } from "@api/TrainingAPI";
import { useEffect, useState } from "react";
import { IAutomaticAction, IAutomaticActionType, IIntegrations } from "./consts";
import AutomaticActionCard from "./AutomaticActionCard";
import { useSelector, useDispatch } from "react-redux";
import { getSandboxDashboards, getTeamPresets } from '@store/actions/team.actions';
import { PresetType } from '@components/PresetSelection';
import { Button, Skeleton, Typography } from "antd";
import "./styles.css";
import { useAuth0 } from "@auth0/auth0-react";
import { isStaffEmail } from "@utils/user_utils";

export const AutomaticActions = () => {
    const trainingAPI = new TrainingAPI();
    const dispatch = useDispatch();
    const [automaticActionData, setAutomaticActionData] = useState<IAutomaticAction[]>([])
    const [actionsLoaded, setActionsLoaded] = useState<boolean>(false)
    const [createNewAutomaticAction, setCreateNewAutomaticAction] = useState<boolean>(false)

    const { user } = useAuth0();

    const {
        info: {
            coach_list: coachList,
            integrations
        },
        misc: {
            automatic_action_types: allAutomaticActionTypes
        },
        presets
    } = useSelector(({ team }) => team);

    useEffect(() => {
        dispatch(getTeamPresets({
            type: [
                PresetType.ReportSettings
            ]
        }) as any)
        dispatch(getSandboxDashboards() as any)
    }, []);

    const automaticActionTypes: IAutomaticActionType[] = allAutomaticActionTypes ?? [];

    const isStaff = isStaffEmail(user?.email);
    const reportPresets = (presets ?? []).filter((p: any) =>
        p.type === PresetType.ReportSettings &&
        (isStaff || !user?.email || p.creator_id__email?.toLowerCase() === user.email.toLowerCase())
    );

    const filteredIntegrations: IIntegrations[] = integrations
        ? Object.values(integrations as IIntegrations).flat().filter((e) => e.type === 'api')
        : [];

    const refetchAutomaticActions = async () => {
        setAutomaticActionData(await trainingAPI.getAutomaticActions())
        setActionsLoaded(true)
    }

    const hideNewAction = () => {
        setCreateNewAutomaticAction(false)
    }

    useEffect(() => {
        (async () => {
            await refetchAutomaticActions()
        })()
    }, [])

    const showEmpty = actionsLoaded && automaticActionData.length === 0 && !createNewAutomaticAction;

    return (
        <div style={{ width: 640, maxWidth: "100%" }}>
            {!showEmpty &&
                <Button
                    type="primary"
                    style={{ marginBottom: '10px' }}
                    disabled={!automaticActionTypes?.length || createNewAutomaticAction}
                    onClick={() => { setCreateNewAutomaticAction(true) }}
                >
                    Add Action
                </Button>
            }

            {!actionsLoaded && <Skeleton active />}

            {createNewAutomaticAction && automaticActionTypes?.length > 0 &&
                <AutomaticActionCard
                    automaticActionData={{
                        frequency: [],
                        is_active: true,
                        metadata: {},
                        scheduled_at: new Date(
                            Math.floor(new Date().getTime() / (1000 * 60 * 5)) * (1000 * 60 * 5)
                        ), // rounds to nearest 5 min
                        action_types_id: undefined,
                        created_at: new Date(),
                        id: ''
                    }}
                    automaticActionTypes={automaticActionTypes}
                    key={`new`}
                    idx={-1}
                    status="new"
                    refetchAutomaticActions={refetchAutomaticActions}
                    hideNewAction={hideNewAction}
                    coachList={coachList}
                    integrations={filteredIntegrations}
                    reportPresets={reportPresets} />
            }

            {showEmpty &&
                <div className="automatic-actions-empty">
                    <Typography.Paragraph type="secondary" style={{ marginBottom: 12 }}>
                        No automatic actions yet
                    </Typography.Paragraph>
                    <Button
                        type="primary"
                        disabled={!automaticActionTypes?.length}
                        onClick={() => { setCreateNewAutomaticAction(true) }}
                    >
                        Add Action
                    </Button>
                </div>
            }

            {automaticActionData.map((data, idx) => {
                return (
                    <AutomaticActionCard
                        automaticActionData={data}
                        automaticActionTypes={automaticActionTypes}
                        key={`${data.id}`}
                        idx={idx}
                        status="old"
                        refetchAutomaticActions={refetchAutomaticActions}
                        hideNewAction={hideNewAction}
                        coachList={coachList}
                        integrations={filteredIntegrations}
                        reportPresets={reportPresets}
                    />
                )
            })}

        </div>
    )
}

export default AutomaticActions